
export default () => ({
	data: [],
	meta: {},
	columns: [],
	originalColumns: [],
	selected: [],
	sortBy: null,
	sortOrder: 'desc',
	filters: []
})
